import { appConfig } from '@/config';
const pending = new Map();
export function syncDefaultFriends(token) {
  if (!token) return Promise.resolve(null);
  if (pending.has(token)) return pending.get(token);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 8000);
  const request = (async () => {
    const response = await fetch(new URL('/business-api/default-friend-sync.php', appConfig.serviceOrigin), {
      signal: controller.signal, method: 'POST', cache: 'no-store', credentials: 'omit',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token })
    });
    const data = await response.json();
    if (!response.ok || !data.ok || !Array.isArray(data.friends)) throw new Error('Default friend sync unavailable');
    return data;
  })().finally(() => { clearTimeout(timeout); pending.delete(token); });
  pending.set(token, request);
  return request;
}
